export const isAttributionParameter = (key) =>
  key.startsWith("utm_") ||
  ["gclid", "gbraid", "wbraid", "gad_source"].includes(key);

const VISIT_ATTRIBUTION_KEY = "play-install-attribution";

export const createPlayStoreAttribution = (storage) => {
  let saved = "";
  const capture = ({ search }) => {
    const incoming = new URLSearchParams();
    for (const [key, value] of new URLSearchParams(search)) {
      if (isAttributionParameter(key)) incoming.append(key, value);
    }
    if (incoming.size > 0) {
      saved = incoming.toString();
      try {
        storage?.setItem(VISIT_ATTRIBUTION_KEY, saved);
      } catch {
        // Storage may be blocked; keep attribution for this page's SPA journey.
      }
    } else if (!saved) {
      try {
        saved = storage?.getItem(VISIT_ATTRIBUTION_KEY) || "";
      } catch {
        // Attribution is optional; a blocked store must not prevent installation.
      }
    }
    return saved;
  };

  return {
    capture,
    buildPlayStoreUrl(location) {
      const attribution = new URLSearchParams(capture(location));
      if (attribution.size === 0) {
        attribution.set("utm_source", "website");
        attribution.set("utm_medium", "organic");
        attribution.set("utm_content", location.pathname);
      }
      const play = new URL("https://play.google.com/store/apps/details");
      play.searchParams.set("id", "com.sababuu.twa");
      play.searchParams.set("referrer", attribution.toString());
      return play.toString();
    },
  };
};

const visit = createPlayStoreAttribution({
  getItem: (key) => window.sessionStorage.getItem(key),
  setItem: (key, value) => window.sessionStorage.setItem(key, value),
});
export const captureAttribution = visit.capture;
export const buildPlayStoreUrl = visit.buildPlayStoreUrl;
